import type { GridViewUser } from "../../../api/users";

export type ResponsibleEntitiesKey = Extract<
  keyof GridViewUser,
  | "registrationsWhereResponsible"
  | "processorRegistrationsWhereResponsible"
  | "dpiasWhereResponsible"
  | "systemsWhereResponsible"
>;

export const RESPONSIBLE_ENTITIES_PATHS: Record<ResponsibleEntitiesKey, string> = {
  registrationsWhereResponsible: "registrations",
  processorRegistrationsWhereResponsible: "processor-registrations",
  dpiasWhereResponsible: "dpia",
  systemsWhereResponsible: "systems",
} as const;
